import { mutator } from 'satcheljs';
import { onInteractionRequiredAuthFailure } from 'owa-msaljs';
import { getStore } from '../store/store';

export const onAuthFailure = mutator(onInteractionRequiredAuthFailure, () => {
    const store = getStore();
    if (!store.isSigninRequired) {
        store.isSigninRequired = true;
    }
});
